var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "landing-page" },
    [
      _c(
        "el-row",
        { staticClass: "container" },
        [
          _c("el-col", { staticClass: "header-section", attrs: { span: 24 } }, [
            _c("h1", { staticClass: "main-title" }, [
              _vm._v(
                "U-Connect: Your Partner in Driving Success and Expanding Revenue"
              )
            ]),
            _vm._v(" "),
            _c("p", { staticClass: "subtitle" }, [
              _vm._v("\n        Welcome to "),
              _c("b", [_vm._v("U-Connect")]),
              _vm._v(
                ", the innovative real estate platform that empowers professionals to collaborate on closing deals for clients\n        seeking off-the-plan and new-build properties. U-Connect brings together real estate agents, buyer’s agents, finance brokers,\n        accountants, and migration agents in a seamless network designed to connect clients with prime real estate opportunities while\n        expanding each professional's reach and revenue potential.\n      "
              )
            ])
          ]),
          _vm._v(" "),
          _c(
            "el-row",
            { staticClass: "content-section" },
            [
              _c("el-col", { attrs: { span: 24 } }, [
                _c("div", { staticClass: "image-container" }, [
                  _c("img", {
                    staticClass: "feature-image",
                    attrs: {
                      src: require("./../../../assets/u-connect-reg-section-2-backgroud.png"),
                      alt: "UNIFI Property Platform Preview"
                    }
                  })
                ])
              ]),
              _vm._v(" "),
              _c(
                "el-col",
                { staticClass: "features-column", attrs: { span: 24 } },
                [
                  _c("h2", { staticClass: "features-title" }, [
                    _vm._v("Unlock New Revenue Streams and Market Access")
                  ]),
                  _vm._v(" "),
                  _c("p", { staticClass: "feature-description" }, [
                    _vm._v(
                      "By joining U-Connect, you gain more than just a\n          platform; you gain a powerful business partner. Each\n          deal closed is a shared success, with selling agents\n          offering a portion of their commission to participating\n          professionals who contribute to completing the\n          transaction. This not only diversifies your income but\n          also fosters a cooperative approach, creating win-win\n          scenarios for all parties involved."
                    )
                  ])
                ]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-112b4020", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-112b4020","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/register/uConnectRegistration/uConnectRegistrationSection2.vue
// module id = null
// module chunks = 